import type { Ref } from 'vue'
import { createSharedComposable, useScrollLock } from '@vueuse/core'
import { computed, onScopeDispose, readonly, shallowRef, watch } from 'vue'

const useSharedScrollLock = createSharedComposable(() => {
  const body = computed(() => (typeof document === 'undefined' ? undefined : document.body))
  const locked = useScrollLock(body)
  const owners = new Set<symbol>()
  const open = shallowRef(false)

  function update(id: symbol, active: boolean) {
    if (active) {
      owners.add(id)
    } else {
      owners.delete(id)
    }
    locked.value = owners.size > 0
    open.value = owners.size > 0
  }

  return { update, open: readonly(open) }
})

export function useOverlayScrollLock(active: Ref<boolean>) {
  const { update } = useSharedScrollLock()
  const id = Symbol('scroll-lock')
  watch(active, value => update(id, value), { immediate: true, flush: 'sync' })
  onScopeDispose(() => update(id, false))
}

/** Whether any modal overlay (Backdrop, BottomSheet, mobile Drawer) is open. */
export function useOverlayOpen() {
  return useSharedScrollLock().open
}
